import React from 'react';

// Erişilebilir aç/kapa anahtarı. Görünen boyut küçük (48x28), dokunma alanı before ile 44px üstüne genişletilir.
const ToggleSwitch = ({ checked, onChange, label, disabled = false }) => (
    <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={`relative inline-flex h-7 w-12 shrink-0 cursor-pointer items-center rounded-full border transition-colors before:absolute before:-inset-3 disabled:cursor-not-allowed disabled:opacity-50 ${
            checked ? 'border-primary-500 bg-primary-600' : 'border-dark-border bg-dark-muted/40'
        }`}
    >
        <span
            className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${
                checked ? 'translate-x-6' : 'translate-x-1'
            }`}
        />
    </button>
);

export default ToggleSwitch;
